import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const collectionsBreadcrumbs = () : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Коллекции',
        url: '',
    },
]);
